<template>
    <div class="app-wrapper">

        <el-container>
            <el-header class="header">
                <navbar class="navbar-container" />
            </el-header>

            <el-main>
                <el-row type="flex">
                    <el-col :span="3">
                        <sidebar class="sidebar-container" />
                    </el-col>
                    <el-col :span="21">
                        <app-main />
                    </el-col>
                </el-row>
            </el-main>

        </el-container>

    </div>

</template>

<script>
import page from "./index.js";
export default page;
</script>

<style lang="scss">
@import "./public.css";
</style>
<style lang="scss" scoped>
@import "./index.css";
</style>


// WEBPACK FOOTER //
// src/layout/master/index.vue